
















































import { createComponent, ref, computed } from "@vue/composition-api";
import { useRouting } from "@dcc/compositions/useRouting";
import { useDictionary } from "@dcc/views/compositions/useDictionary";

import { BaseLink, BasePrimaryButton } from "@web-components";
/*eslint-disable */
import DrinkingTabs from "@dcc/components/DrinkingTabs.vue";
import { UpdateDrink } from "@dcc/views/types/updateDrink";
/*eslint-enable */
import { findGetters } from "@dcc/store/drinking/getters";
import { getActions } from "@dcc/store/drinking/actions";

import { MIN_DRINKS, MAX_DRINKS } from "@dcc/constants/drinkConstants";
import { daysOfWeekText } from "@dcc/types/dayOfWeek";
import { AVERAGEDAY } from "@dcc/types/averageDay";
import {
  averageDayTabLabels,
  tabsEnabled
} from "@dcc/views/types/averageDayDrinkingTabs";

export default createComponent({
  components: {
    BaseLink,
    DrinkingTabs,
    BasePrimaryButton
  },
  setup(props: {}, context) {
    const { handleNext, handlePrev } = useRouting(context);
    const dictionary = useDictionary();
    const currentTab = ref(0);

    const { getTotalDrinksOnAverageDay, getDrinksOnAverageDay } = findGetters(
      context.root.$store
    );
    const { updateAverageDayDrinkQuantity } = getActions(context.root.$store);
    const totalDrinksOnAverageDay = getTotalDrinksOnAverageDay();
    const drinksObject = getDrinksOnAverageDay();

    const drinksOnAverageDay = computed(() => [
      {
        day: AVERAGEDAY,
        amount: totalDrinksOnAverageDay.value,
        ...drinksObject.value
      }
    ]);

    const nextIsDisabled = computed(() => totalDrinksOnAverageDay.value <= 0);

    const updateDrink = ({ drink, amount }: UpdateDrink) => {
      updateAverageDayDrinkQuantity({
        drink,
        amount: Number(amount)
      });
    };
    return {
      currentTab,
      drinksOnAverageDay,
      averageDayTabLabels,
      daysOfWeekText,
      MIN_DRINKS,
      MAX_DRINKS,
      nextIsDisabled,
      tabsEnabled,
      updateDrink,
      handleNext,
      handlePrev,
      ...dictionary
    };
  }
});
